/**
 * Journey Update Schemas
 *
 * Cornerstone refactor 2026-05: lifecycle and funding mutations are
 * owned by JourneyStateService server-side. This DTO only accepts the
 * payload-side fields (household, scope) — clients can no longer
 * direct-update `unlockMode` / `lifecycleState` / `fundingSource`.
 */

import { z } from 'zod';
import { householdConfigSchema } from './create';

export const lifecycleStateSchema = z.enum([
  'draft',
  'pending_setup',
  'active',
  'paused',
  'expired',
  'completed',
  'cancelled',
]);

/**
 * F48: `heroesEnabled` is gone from this DTO. Cornerstone v2 dropped the
 * `journey_instances.heroes_enabled` column, and the repository's `update()`
 * destructured the key and threw it away — so the contract advertised a field
 * the platform accepted and did not store. A field that is silently discarded
 * is worse than a missing one: the caller believes it landed.
 */
export const updateJourneySchema = z.object({
  householdConfig: householdConfigSchema.optional(),
});

export type UpdateJourneyInput = z.infer<typeof updateJourneySchema>;

export const activateJourneySchema = z.object({
  startDate: z.coerce.date().optional(),
});

export type ActivateJourneyInput = z.infer<typeof activateJourneySchema>;

export const pauseJourneySchema = z.object({
  reason: z.string().max(500).optional(),
});

export type PauseJourneyInput = z.infer<typeof pauseJourneySchema>;
